import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmopPublicWorkflowApprovalService } from './emop-public-workflow-approval.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { EmopFormProClass } from '../../../app/class/EmopFormProClass/EmopFormProClass';

@Component({
  selector: 'emop-public-workflow-approval',
  templateUrl: './emop-public-workflow-approval.component.html',
  styleUrls: ['./emop-public-workflow-approval.component.scss']
})
export class EmopPublicWorkflowApprovalComponent implements OnInit {

  /**
   * 当前流程的id
   */
  @Input() processInstanceId: string = '';
  @Input() approvalTableHeader: { alias: string, key: string; }[] = [];
  @Input() showForm: boolean = false;
  @Input() onApprovalTableClick: Function;
  @Output() confirm = new EventEmitter;

  constructor(
    public EmopPublicWorkflowApprovalService: EmopPublicWorkflowApprovalService,
    private NzMessageService: NzMessageService
  ) { }

  ngOnInit(): void {
    this.EmopPublicWorkflowApprovalService.formData = new EmopFormProClass([]);
    if (!this.processInstanceId) console.error('请提供processInstanceId');
    this.EmopPublicWorkflowApprovalService.processInstanceId = this.processInstanceId;
    this.EmopPublicWorkflowApprovalService.showForm = this.showForm;
    this.EmopPublicWorkflowApprovalService.approvalObjectTable.header = this.approvalTableHeader;
    this.EmopPublicWorkflowApprovalService.onApprovalTableClick = this.onApprovalTableClick;
  }
  /**
   * 审批记录
   */
  approvalConfirm() {

  }
  confirmFn(data) {
    this.confirm.emit(data);
  }
}
